import { Button } from "@svea/design-system-components-react";
import {
	type AnsweredQuestion,
	type AnyQuestion,
	ButtonGroup,
	getQuestionnaireInitialValues,
	parseFormValues,
	Question,
	type QuestionnaireFormValues,
	Stack,
	useText,
} from "@sveabank/cc-common";
import { Form } from "react-final-form";
import { usePageContext } from "../../../../hooks/context";
import { useClcCompanyApplication } from "../../hooks";

type Props = {
	// questions: Array<AnyQuestion>;
	onSubmit: (questions: AnsweredQuestion[]) => Promise<void>;
	onCancel: () => void;
};

export const ClcApplicationQuestions = ({ onSubmit, onCancel }: Props) => {
	const { sortedCountries, clcApplicationQuestions } = usePageContext(useClcCompanyApplication);

	const submitAnswers = async (questions: Array<AnyQuestion>, values: QuestionnaireFormValues) =>
		onSubmit(parseFormValues(questions, values));

	const initialValues = getQuestionnaireInitialValues(clcApplicationQuestions);

	const [t, texts] = useText();

	return (
		<Form<QuestionnaireFormValues>
			onSubmit={(values) => {
				return submitAnswers(clcApplicationQuestions, values);
			}}
			initialValues={initialValues}
			render={({ handleSubmit, submitting }) => (
				<form onSubmit={handleSubmit}>
					<Stack gap={6}>
						{clcApplicationQuestions.map((q) => (
							<Question question={q} key={q.questionId} allCountries={sortedCountries} />
						))}
						<ButtonGroup row align="start">
							<Button type="button" variant="secondary" onPress={onCancel}>
								{t(texts.common.abort)}
							</Button>
							<Button
								type="submit"
								isPending={submitting}
								data-tracking-action="CLC Application Continue"
								data-tracking-name="Company AML Questions"
							>
								{t(texts.common.save)}
							</Button>
						</ButtonGroup>
					</Stack>
				</form>
			)}
		/>
	);
};
